var _path, _rect, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapLineSmallSqaure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 15.2221V8.33337C17 8.01192 16.8455 7.71007 16.5847 7.52212C16.3239 7.33417 15.9887 7.28304 15.6837 7.3847L13.9829 7.9517C13.7776 8.02014 13.5557 8.02014 13.3504 7.9517L10.6496 7.05133C10.4443 6.98289 10.2224 6.98289 10.0171 7.05133L7.6837 7.82933C7.27539 7.96547 7 8.34759 7 8.778V15.6667C7 15.9882 7.15453 16.29 7.41532 16.478C7.67611 16.6659 8.01135 16.717 8.3163 16.6154L10.0171 16.0483C10.2224 15.9799 10.4443 15.9799 10.6496 16.0483L13.3504 16.9487C13.5557 17.0171 13.7776 17.0171 13.9829 16.9487L16.3163 16.1708C16.7246 16.0347 17 15.6525 17 15.2221Z",
    stroke: "#1C1B1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 21,
    width: 18,
    height: 18,
    rx: 5,
    transform: "rotate(180 21 21)",
    stroke: "#1C1B1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.667 10.8981V13.3981",
    stroke: "#1C1B1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.333 13.102L10.3331 10.602",
    stroke: "#1C1B1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapLineSmallSqaure);
export default __webpack_public_path__ + "static/media/map-line-small-sqaure.adcb3b7c87c8d5bb076a59c4bd6298fe.svg";
export { ForwardRef as ReactComponent };